import { Fragment } from 'react'
import PropTypes from 'prop-types'

export default function IntroCopy({ grade, summary }) {
  let heading
  let blurb
  let full

  // Only look at first letter-part of grade
  switch (grade.charAt(0)) {
    case 'A':
      heading = 'Congrats!'
      blurb = "Based on your answers about this service, you're in great shape."
      full =
        "Based on your answers about this service, you're in great shape. Ensure this service maintains high marks by continuing to monitor and measure availability KPIs and running regular Chaos Engineering experiments to ensure the service is resilient to an increasingly wide range of failure scenarios."
      break
    case 'B':
      heading = 'Nice work!'
      blurb =
        "Based on your answers, you're well on your way to building a highly reliable service."
      full =
        "Based on your answers, you're well on your way to building a highly reliable service. Improve this service's grade by monitoring and measuring availability KPIs and running regular Chaos Engineering experiments to ensure the service is resilient to an increasingly wide range of failure scenarios."
      break
    case 'C':
      heading = "You're off to a good start."
      blurb =
        'Based on your answers, there are several opportunities for you to improve the reliability of this service.'
      full =
        "Based on your answers, there are several opportunities for you to improve the reliability of this service. Simple interventions like tuning your monitoring and alerting, running small Chaos Engineering experiments, and establishing error budgets will have a significant impact on this service's grade."
      break
    case 'F':
      heading = "There's work left to do!"
      blurb =
        'Based on your answers, immediate steps should be taken to improve the reliability of this service. '
      full =
        "Based on your answers, immediate steps should be taken to improve the reliability of this service. Simple interventions like tuning your monitoring and alerting, running small Chaos Engineering experiments, and establishing error budgets will have a significant impact on this service's grade."
      break
    default:
      heading = "There's work left to do!"
      blurb =
        'Based on your answers, immediate steps should be taken to improve the reliability of this service. '
      full =
        "Based on your answers, immediate steps should be taken to improve the reliability of this service. Simple interventions like tuning your monitoring and alerting, running small Chaos Engineering experiments, and establishing error budgets will have a significant impact on this service's grade."
      break
  }

  return (
    <Fragment>
      <h3>{heading}</h3>
      <hr />

      {summary ? (
        <Fragment>
          <p>{blurb}</p>
          <p>
            Submit your email to get your full list of personalized
            recommendations and to see how we calculated your score.
          </p>
        </Fragment>
      ) : (
        <p>{full}</p>
      )}
    </Fragment>
  )
}

IntroCopy.propTypes = {
  grade: PropTypes.string.isRequired,
  summary: PropTypes.bool,
}
